import React from "react";

export type TArrawUpIconProps = React.SVGAttributes<SVGElement>;

export function ArrawUpIcon({ ...rest }: TArrawUpIconProps) {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99996 2.46392L1.28576 8L0 6.75432L6.97164 0L6.99996 0.0274377L7.02828 0L13.9999 6.75432L12.7142 
          8L6.99996 2.46392Z"
        fill="#7F94A1"
      />
    </svg>
  );
}
